import styled from "styled-components";

export const SessionPageContainer = styled.div`
  margin: 5.5rem 2rem 2.5rem 2rem;

  @media screen and (max-width: 500px) {
    margin: 1rem 1.5rem;
  }
`;

export const ContentArea = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);

  @media screen and (max-width: 500px) {
    margin-top: 6.4rem;
  }
`;

export const IntroArea = styled.div`
  display: flex;
  gap: 50px;

  @media screen and (max-width: 600px) {
    flex-direction: ${(props) =>
      props.invertOrderOnMobile ? "column-reverse" : "column"};
    gap: 0;
  }
`;

export const SessionImageContainer = styled.div`
  width: 50%;
  overflow: hidden;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const IntroTextContainer = styled.div`
  width: 50%;

  @media screen and (max-width: 600px) {
    width: 100%;
    margin-top: 1.5rem;
  }
`;

export const BiggerText = styled.div`
  font-size: 18px;
  margin-bottom: 1.8rem;

  @media screen and (max-width: 600px) {
    text-align: left;
  }
`;

export const TertiaryTitle = styled.p`
  font-size: x-large;
  text-align: center;
`;

export const InPersonSessionImage = styled.div`
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 80vh;

  @media screen and (max-width: 600px) {
    height: 55vh;
  }
`;

export const SubTitle = styled.h2`
  font-family: "Ysabeau";
  font-weight: 300;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-bone);
`;

export const SectionHeading = styled.h2`
  font-family: "Ysabeau";
  font-weight: 300;
  font-size: 2.2rem;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: var(--color-bone);
  margin: 0 0 0.5rem;

  @media screen and (max-width: 600px) {
    font-size: 1.6rem;
    letter-spacing: 0.12em;
  }
`;

export const AccentBar = styled.div`
  width: 2.5rem;
  height: 1px;
  background: var(--color-emphasis);
  margin: 0.75rem auto 1.75rem;
`;

export const Divider = styled.hr`
  all: unset;
  display: block;
  width: 0.5px;
  height: 64px;
  background: var(--color-bone);
  margin: 1.5rem auto;
  transform-origin: center;
`;
